export default "__VITE_ASSET__C6h5mAQY__"